import { render, staticRenderFns } from "./message-face.vue?vue&type=template&id=518a523d&scoped=true"
import script from "./message-face.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-face.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-face.vue?vue&type=style&index=0&id=518a523d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518a523d",
  null
  
)

export default component.exports